export const ADD_FILTER_OPTION = 'ADD_FILTER_OPTION';

export function addFilterOption(name, label, options){
	return { type: ADD_FILTER_OPTION, name, label, options }
}
